// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"dd4e984a","477":"c9e1ba56"}[chunkId] + ".chunk.js";
};